import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader, LoaderCircle } from "lucide-react";

function Button({
  children,
  onClick,
  className = "",
  Icon = null,
  IconRight = null,
  type = "button", // 'button' | 'submit' | 'link' | 'getcode'
  to = "",
  loading = false,
  disabled = false,
  disableTime = 0, // disableTime in seconds ⏱️
  state = undefined,
  transactionType = "", // only used when type = getcode
  target = '',
  style = {}
}) {
  const [tempDisabled, setTempDisabled] = useState(false);

  const isDisabled =
    className.includes("disabled") || loading || disabled || tempDisabled;

  const handleClick = (e) => {
    if (disableTime > 0) {
      setTempDisabled(true);
      setTimeout(() => {
        setTempDisabled(false);
      }, disableTime * 1000);
    }

    if (type === "getcode") {
      const props = { TransactionType: transactionType };
      // sendEmail(props);
    }

    if (onClick && !isDisabled) {
      onClick(e);
    }
  };

  // ✅ Handle link type properly
  if (type === "link" && to) {
    const isExternal = to.startsWith("http");

    if (isExternal) {
      // External link (use <a>)
      return (
        <a
          style={style}
          href={to}
          target={target || "_blank"}
          rel="noopener noreferrer"
          className={`button ${className} ${isDisabled ? "disabled pointer-none" : ""
            }`}
          onClick={handleClick}
        >
          {loading ? (
            <Loader className="spin" />
          ) : (
            <>
              {IconRight && <span className="icon">{IconRight}</span>}
              {children}
              {Icon && <span className="icon">{Icon}</span>}
            </>
          )}
        </a>
      );
    } else {
      // Internal link (use <Link>)
      return (
        <Link
          style={style}
          to={to}
          state={state}
          className={`button ${className} ${isDisabled ? "disabled pointer-none" : ""
            }`}
          onClick={handleClick}
        >
          {loading ? (
            <Loader className="spin" />
          ) : (
            <>
              {IconRight && <span className="icon">{IconRight}</span>}
              {children}
              {Icon && <span className="icon">{Icon}</span>}
            </>
          )}
        </Link>
      );
    }
  }

  return (
    <button
      type={type === "getcode" ? "button" : type} // keep button type valid
      className={`button ${className}`}
      onClick={handleClick}
      disabled={isDisabled}
      style={style}
    >
      {loading ? (
        <><Loader className="spin" /> Loading...</>
      ) : (
        <>
          {IconRight && <span className="icon">{IconRight}</span>}
          {children}
          {Icon && <span className="icon">{Icon}</span>}
        </>
      )}
    </button>
  );
}

export default Button;
